// Plugin para gerar os labels fora do gráfico
export const outlabelsPlugin = {
  id: "outlabels",
  afterDraw: (chart: any) => {
    const ctx = chart.ctx;
    const chartArea = chart.chartArea;
    const centerX = (chartArea.left + chartArea.right) / 2;
    const centerY = (chartArea.top + chartArea.bottom) / 2;

    chart.data.datasets.forEach((dataset: any, datasetIndex: number) => {
      const meta = chart.getDatasetMeta(datasetIndex);
      const total = dataset.data.reduce(
        (acc: number, val: number) => acc + val,
        0
      );

      meta.data.forEach((arc: any, index: number) => {
        const value = dataset.data[index];
        const percentage = ((value / total) * 100).toFixed(1);
        const label = chart.data.labels[index];

        const angle = (arc.startAngle + arc.endAngle) / 2;
        const radius = arc.outerRadius;

        // Ponta do arco
        const x1 = centerX + Math.cos(angle) * radius;
        const y1 = centerY + Math.sin(angle) * radius;

        const lineLength = 40;
        const x2 = centerX + Math.cos(angle) * (radius + lineLength);
        const y2 = centerY + Math.sin(angle) * (radius + lineLength);

        const horizontalLength = 50;
        const x3 =
          x2 + (Math.cos(angle) > 0 ? horizontalLength : -horizontalLength);
        const y3 = y2;

        // Linha
        ctx.save();
        ctx.strokeStyle =
          dataset.backgroundColor[index % dataset.backgroundColor.length];
        ctx.lineWidth = 8;
        ctx.beginPath();
        ctx.moveTo(x1, y1);
        ctx.lineTo(x2, y2);
        ctx.lineTo(x3, y3);
        ctx.stroke();

        // Circulo
        ctx.fillStyle =
          dataset.backgroundColor[index % dataset.backgroundColor.length];
        ctx.beginPath();
        ctx.arc(x2, y2, 8, 0, 2 * Math.PI);
        ctx.fill();

        // Texto
        ctx.fillStyle = "#000";
        ctx.font = "bold 52px Arial";
        ctx.textBaseline = "middle";

        const textX = x3 + (Math.cos(angle) > 0 ? 10 : -10);
        const align = Math.cos(angle) > 0 ? "left" : "right";
        ctx.textAlign = align;

        // Porcentagem
        ctx.fillText(`${percentage}%`, textX, y3 - 20);

        // Label
        ctx.font = "46px Arial";
        ctx.fillStyle = "#000";
        ctx.fillText(label, textX, y3 + 25);

        ctx.restore();
      });
    });
  },
};
